<template>
    <a v-if="ConfigShowShopBanner" class="d-block ma-auto pa-2" target="_blank" style="font-size:14px" :href="ConfigShopURL">Looking for supplies for your printer?</a>
</template>

<script>
import {CommonMixins} from "@/mixins/CommonMixins";

export default {
    mixins: [CommonMixins]
}
</script>
